<template>
  <div id="Platen" class="w-100 h-100">
    <div class="w-100 h-100" v-if="!isEdit">
      <div class="list-content p-10">
        <el-row type="flex" align="middle">
          <el-col :span="22">
            <el-input
              v-model="searchKey"
              placeholder="型号或名称搜索"
              clearable
              size="small"
            ></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="filterNodeList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <div class="table-content m-t-10 h-100">
          <el-table
            :data="dataList"
            v-loading="tableLoading"
            class="w-100"
            max-height="calc(100% - 42px)"
            height="calc(100% - 42px)"
            @select="selectionTableChange"
            ref="nodeTable"
          >
            <el-table-column type="selection" align="center" width="55"></el-table-column>
            <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
            <el-table-column label="压板布局" align="center" prop="code.layout"></el-table-column>
            <el-table-column label="压板型号" align="center" prop="code.model"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="card-footer fz-12 w-100 m-t-10 m-b-10">
        <el-row type="flex" align="middle" class="w-100">
          <el-col :span="12"
            ><el-button type="primary" size="mini" @click="addNode">新增</el-button></el-col
          >
          <el-col :span="12" class="tr"
            ><el-button type="primary" size="mini" @click="editNode">修改</el-button
            ><el-button type="primary" size="mini" @click="deleteNode">删除</el-button></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="Platen_style fz-12" v-if="isEdit && !selectionNode">
      <div class="p-10">
        <p>压板背板样式</p>
      </div>
      <div class="model-list p-l-10 p-r-10">
        <el-row>
          <el-col :span="6" v-for="(item, index) in deviceList" :key="index">
            <div class="w-100 model-item p-10 cur-pointer">
              <div class="w-100 item-img">
                <img
                  class="w-100 h-100"
                  :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
                  width="100%"
                  height="100%"
                  alt=""
                />
              </div>
              <div
                class="w-100 item-title ell tc"
                @click="
                  (e) => {
                    e.stopPropagation()
                  }
                "
              >
                <el-checkbox
                  v-model="item.select"
                  @change="selectChange(item)"
                  class="text-color-white d-flex flex-align-center m-t-5 m-l-10 m-r-10"
                  >{{ item.name }}</el-checkbox
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div
      class="Platen_layout fz-12"
      v-if="isEdit"
      :style="{
        height: selectionNode ? 'calc(100% - 48px)' : '95px',
        marginTop: selectionNode ? '0px' : '10px',
      }"
    >
      <el-row>
        <el-col :span="5">
          <span class="Platen_layout_title">压板开关布局</span>
        </el-col>
        <el-col :span="19">
          <el-row type="flex" align="middle" class="m-t-10">
            <el-col :span="9">
              <el-input
                v-model="inputRow"
                @blur="plateCountChange(inputRow)"
                size="mini"
                type="text"
                oninput="value = value.replace(/[^\d.]/g,'')"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <span class="m-l-5">行</span>
            </el-col>
            <el-col :span="9">
              <el-input
                v-model="inputColumn"
                @blur="plateCountChange(inputColumn)"
                size="mini"
                type="text"
                oninput="value = value.replace(/[^\d.]/g,'')"
              ></el-input>
            </el-col>
            <el-col :span="3">
              <span class="m-l-5">列</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-button size="small" class="Platen_layout_edit" @click="platenName" type="primary"
        >压板名称编辑</el-button
      >
    </div>
    <div class="Platen_back_style fz-12 m-t-10" v-if="isEdit && !selectionNode">
      <div class="Platen_back_top p-10">
        <el-row type="flex" align="middle">
          <el-col :span="4">
            <p>开关样式</p>
          </el-col>
          <el-col :span="18">
            <el-input v-model="searchTypeKey" placeholder="名称搜索" size="small"></el-input>
          </el-col>
          <el-col class="tr" :span="2">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                @click="getOtherDataList(defaultOtherFolderId)"
                class="iconfont icon-search"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <div class="model-list p-l-10 p-r-10">
        <el-row>
          <el-col :span="6" v-for="(item, index) in deviceOtherList" :key="index">
            <div class="w-100 model-item p-10 cur-pointer">
              <div class="w-100 item-img">
                <img
                  class="w-100 h-100"
                  :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
                  width="100%"
                  height="100%"
                  alt=""
                />
              </div>
              <div
                class="w-100 item-title ell tc"
                @click="
                  (e) => {
                    e.stopPropagation()
                  }
                "
              >
                <el-checkbox
                  v-model="item.select"
                  @change="selectOtherChange(item)"
                  class="text-color-white d-flex flex-align-center flex-row-center m-t-5"
                  >{{ item.name }}</el-checkbox
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="card-footer w-100 m-t-10" v-if="isEdit">
      <el-row type="flex" align="middle" v-if="!selectionNode">
        <el-col :span="9">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-radio-group v-model="addTypeValue" class="d-flex flex-align-center" disabled>
              <el-radio size="small" :label="1">锚点位置</el-radio>
              <el-radio size="small" :label="2">按节点</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="8" class="p-l-5 p-r-5">
          <el-select
            v-model="nodePositionValue"
            placeholder="中心"
            size="mini"
            popper-class="document_select-popper"
            disabled
          >
            <el-option
              v-for="item in nodePostionProp"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" class="tr"
          ><el-button size="mini" @click="cancleModify">取消</el-button>
          <el-button type="primary" size="mini" @click="loadNode">新增</el-button></el-col
        >
      </el-row>
      <el-row type="flex" align="middle" class="w-100" v-else>
        <el-col :span="12"> </el-col>
        <el-col :span="12" class="tr"
          ><el-button size="mini" @click="cancleModify">取消</el-button>
          <el-button type="primary" size="mini" @click="saveModifyResult">保存</el-button></el-col
        >
      </el-row>
    </div>
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
    <el-dialog
      title="压板名称编辑"
      :visible.sync="platenEdit"
      width="55%"
      :close-on-click-modal="false"
      :lock-scroll="true"
      :before-close="modifyDialogClose"
      :modal-append-to-body="false"
    >
      <div class="PlatenEidt w-100">
        <div class="PlatenEidt_content w-100">
          <div
            class="PlatenEidt_content_row w-100"
            v-for="(itemP, index) in EditCardList"
            :key="index"
          >
            <div
              class="context_card m-t-10 m-l-10 p-10"
              v-for="(item, index) in itemP"
              :key="index"
            >
              <p class="card_title fz-14">{{ item.toolName }}</p>
              <el-row class="fz-12 w-100 m-t-5" type="flex" align="middle">
                <el-col :span="6">
                  <el-tooltip effect="dark" content="文字大小" placement="top">
                    <p class="w-100 ell">文字大小</p>
                  </el-tooltip>
                </el-col>
                <el-col :span="8">
                  <el-input size="mini" v-model="item.fontSize" placeholder="字体大小"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-checkbox class="m-l-10" v-model="item.status" label="开启"></el-checkbox>
                </el-col>
              </el-row>
              <el-input
                size="mini"
                class="w-100 m-t-10"
                v-model="item.firstRow"
                placeholder="请输入第一行文字"
              ></el-input>
              <el-input
                size="mini"
                class="w-100 m-t-10"
                v-model="item.secondRow"
                placeholder="请输入第二行文字"
              ></el-input>
              <el-input
                size="mini"
                class="w-100 m-t-10"
                v-model="item.objNumber"
                placeholder="关联对象编号"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="platenEdit = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="savePlatenEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { loadFbxModel, loadPrModel, isJSONObj, generateGUID } from '../../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  name: 'Platen',
  props: ['player', 'updateNode', 'watchNodeModify', 'documentId', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  watch: {
    // 监听循环次数，每次变化时执行下一次端子模型创建任务
    async circulateNumber(val) {
      if (val === 1) {
        await this.getPlatenPositionInfo()
        this.loadPlaten_OtherNode()
      } else if (val <= this.LoadNumber && val !== 0) {
        this.nodePosition = this.nodePositionList[this.circulateNumber - 1]
        this.addModel(
          this.currentSwitchMd5,
          this.currentSwitchFile,
          this.currentSwitchInfo,
          this.currentSwitchMaterial
        )
      } else if (val > this.LoadNumber) {
        // 加载完成时重置加载数据
        this.circulateNumber = 0
        this.isSelectOtherList = ''
        this.isSelectList = ''
        this.LoadNumber = 0
        this.circulateNumber = 0
        this.nodePositionList = []
        this.inputRow = 0
        this.inputColumn = 0
        this.PlatenPosition = [] // 背板的包围盒信息
        this.currentSwitchModel = ''
        this.currentSwitchMd5 = ''
        this.currentSwitchFile = ''
        this.currentSwitchInfo = {}
        this.currentSwitchMaterial = {}
        this.$emit('updateEditTree', this.currentCreatedNode)
      }
    },
    updateNode() {
      this.getPlatenList()
    },
    watchNodeModify() {
      this.getPlatenList()
    },
  },
  async created() {
    this.getPlatenList()
    await this.getFolderClassId()
    await this.getLabelFolderClassId()
    await this.getOtherFolderClassId()
    // 获取属性模板
    await this.getAttributeTemplateList()
    // 获取背板列表
    await this.getDataList(this.defaultFolderId)
    await this.getLabelDataList(this.defaultLabelFolderId)
    // 获取压板样式列表
    this.getOtherDataList(this.defaultOtherFolderId)
  },
  methods: {
    // 保存更改
    async saveModifyResult() {
      console.log(this.selectionNode)
      this.selectionNode.code.layout = `${this.inputRow}*${this.inputColumn}`
      await this.player.Native.NodeProxy.setNodeInfo(this.selectionNode.nodePtr, {
        code: JSON.stringify(this.selectionNode.code),
      })
      const platenChilds = await this.player.Native.NodeProxy.getNodeChildren(
        this.selectionNode.nodePtr
      )
      const switchList = _.filter(platenChilds, (item) => {
        return isJSONObj(item.code) && JSON.parse(item.code).type === 'PlatenSwitch'
      })
      if (!_.isEmpty(switchList)) {
        const switchData = isJSONObj(switchList[0].code) ? JSON.parse(switchList[0].code) : {}
        const editNode = await this.player.Native.NodeEditor.node()
        for (let i = 0; i < switchList.length; i += 1) {
          const item = switchList[i]
          // eslint-disable-next-line no-await-in-loop
          if (editNode === item.nodePtr) {
            // eslint-disable-next-line no-await-in-loop
            await this.player.Native.NodeEditor.setNode(0)
          }
          // eslint-disable-next-line no-await-in-loop
          await this.player.Native.NodeProxy.destroyNode(item.nodePtr)
        }
        const plateNodes = await this.player.Native.NodeProxy.getNodeChildren(
          this.selectionNode.nodePtr
        )
        if (plateNodes.length > 0 && plateNodes[0].item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(plateNodes[0].item)
          this.nodePosition = Aabb.faceCenter(calcData.aabb, 'YN')
        }
        this.currentPlatenNode = this.selectionNode.nodePtr
        this.PlatenPosition = plateNodes[0]
        this.isSelectOtherList = [{ id: switchData.documentId }]
        this.currentNodeName = switchData.documentName
        this.circulateNumber += 1
      }
      console.log(switchList)
    },
    // 关闭编辑框
    modifyDialogClose() {
      this.$confirm('您编辑的内容未保存，是否保存编辑?', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '关闭',
        lockScroll: false,
        type: 'warning',
      })
        .then(() => {
          this.savePlatenEdit()
        })
        .catch(() => {
          this.EditCardList = []
          this.platenEdit = false
        })
    },
    // 保存文字及编号编辑
    savePlatenEdit() {
      this.platenEditSaveList = this.EditCardList.reduce((x, y) => {
        return x.concat(y)
      })
      this.EditCardList = []
      this.platenEditList = _.cloneDeep(this.platenEditSaveList)
      this.platenEdit = false
    },
    // 模型加载相关
    // 加载模型
    async createNode(data) {
      this.currentCreateParams = _.cloneDeep(data)
      if (this.currentCreateParams.positionType === 'PressurePlateStyle') {
        this.nodePosition = this.nodePositionList[this.circulateNumber - 1]
      }
      _.forEach(this.currentCreateParams.documentDataList, (item) => {
        this.getDocumentFileList(item)
      })
    },
    // 绘制标签贴图
    async drawNodeMaterial(node, name, md5, fontSize, params) {
      const guid = generateGUID()
      const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${guid}.png`
      const canvas = document.createElement('canvas')
      canvas.width = 200
      canvas.height = 100
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      ctx.textAlign = 'center'
      ctx.fillStyle = '#ff0000'
      canvas.t
      ctx.font = `${fontSize}px arial`
      if (name.length === 2) {
        for (let i = 0; i < 2; i++) {
          if (i === 0) {
            ctx.fillText(name[i], 100, 48)
          } else {
            ctx.fillText(name[i], 100, 60)
          }
        }
      } else {
        ctx.fillText(name[0], 100, 55)
      }
      const imgUrl = canvas.toDataURL('image/png')
      canvas.remove()
      await this.player.Native.File.downloadFile(url, 'GET', imgUrl, {}, async (res) => {
        this.setNodeMaterial(node, url, guid, md5, params)
      })
    },
    //
    async setNodeMaterial(node, imgUrl, guid, md5, params) {
      const codeInfo = _.cloneDeep(params)
      const panelNode = await this.player.Native.NodeProxy.findFirstNodeByName(node, '_NamePanel1')
      const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(panelNode)
      if (materialPtr) {
        const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
        await this.player.Native.NodeProxy.setNodeMaterial(panelNode, copyMaterial)
        await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, imgUrl)
      }
      codeInfo.tagInfo = {
        text: '',
        id: guid,
        file: `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${guid}.png`,
      }
      await this.player.Native.NodeProxy.setNodeInfo(node, { code: JSON.stringify(codeInfo) })
      this.circulateNumber += 1
    },
    // 计算加载点位数据
    async getPlatenPositionInfo() {
      const calcData = await this.player.Native.ModelTree.calcItemAabbData(this.PlatenPosition.item)

      const nodePositionZN = Aabb.faceCenter(calcData.aabb, 'ZN')
      const nodePositionZ = Aabb.faceCenter(calcData.aabb, 'Z')
      const HighDifference = nodePositionZ[2] - nodePositionZN[2]
      const nodePositionXN = Aabb.faceCenter(calcData.aabb, 'XN')
      const nodePositionX = Aabb.faceCenter(calcData.aabb, 'X')
      const WidthDifference = nodePositionX[0] - nodePositionXN[0]
      const posYN = Aabb.faceCenter(calcData.aabb, 'YN')
      // 计算左上角点位
      const X = this.nodePosition[0] - WidthDifference * 0.5
      const Z = this.nodePosition[2] + HighDifference * 0.5
      // 计算加载点位
      const array = []
      let row = 1
      for (let i = 0; i < Number(this.inputRow); i++) {
        let Column = 1
        for (let s = 1; s <= Number(this.inputColumn); s++) {
          const posX = X + (WidthDifference / this.inputColumn) * (Column - 0.5)
          const posY = posYN[1]
          const posZ = Z - (HighDifference / this.inputRow) * (row - 0.5)
          const NodePos = [posX, posY, posZ]
          array.push(NodePos)
          Column++
        }
        row++
      }
      this.nodePositionList = array
    },
    // 获取标签的文件路径id
    async getLabelFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '标签',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '标签'
          })
          if (currentFolder) {
            this.defaultLabelFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取查找文档关联文件
    async getDocumentFileList(data) {
      const res = await DocumentManagementService.getFileList({
        id: data.id,
      })
      if (res && res.data) {
        this.checkModel(res.data)
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
        (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            this.addModel(
              item.md5,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
              item,
              materialParams
            )
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, item.fileType, item, materialParams)
          }
        }
      )
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          that.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                that.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          that.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取文档属性模板信息
    async getDocDetail(id) {
      const res = await DocumentManagementService.getDocumentEdite({
        id,
      })
      if (res && res.code === 0 && res.data) {
        if (!_.isEmpty(res.data.templateAttrSetList)) {
          const val = _.find(res.data.templateAttrSetList[0].attrValueList, (el) => {
            return el.fieldName === 'type'
          })
          return val ? val.attrValue : ''
        }
      }
      return ''
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      let modelName = ''
      if (this.currentCreateParams.type === 'Platen') {
        modelName = await this.getDocDetail(item.documentId)
      } else {
        modelName = this.currentSwitchModel
      }
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      const parentNode = this.currentNodeData.nodePtr ? this.currentNodeData.nodePtr : rootNode
      if (this.currentCreateParams.type === 'Platen') {
        // 卸载模型之后获取偏移量
        await this.getNodeOffset()
      }
      if (item.fileType === '.pr') {
        this.currentCreatedNode = await loadPrModel(
          url,
          this.circulateNumber > 0
            ? this.platenEditList[this.circulateNumber - 1].objNumber || item.documentName
            : item.documentName,
          this.currentCreateParams.type === 'Platen' ? parentNode : this.currentPlatenNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        this.currentCreatedNode = await loadFbxModel(
          url,
          this.circulateNumber > 0
            ? this.platenEditList[this.circulateNumber - 1].objNumber || item.documentName
            : item.documentName,
          this.currentCreateParams.type === 'Platen' ? parentNode : this.currentPlatenNode,
          this.player
        )
      } else {
        this.currentCreatedNode = await this.player.Native.NodeProxy.loadModelNode(
          this.currentCreateParams.type === 'Platen' ? parentNode : this.currentPlatenNode,
          url,
          this.platenEditList[this.circulateNumber].objNumber || item.documentName
        ) // 加载模型
      }
      // 获取开关的包围盒信息
      if (this.currentCreateParams.type === 'PlatenSwitch') {
        this.currentSwitchModel = modelName
        this.currentSwitchMd5 = md5
        this.currentSwitchFile = url
        this.currentSwitchInfo = _.cloneDeep(item)
        this.currentSwitchMaterial = _.cloneDeep(materialParams)
        this.PlatenOtherPosition = await this.player.Native.NodeProxy.getNodeInfo(
          this.currentCreatedNode
        )
        const calcOtherData = await this.player.Native.ModelTree.calcItemAabbData(
          this.PlatenOtherPosition.item
        )
        const SwitchPosY = Aabb.faceCenter(calcOtherData.aabb, 'Y')
        const SwitchPosYN = Aabb.faceCenter(calcOtherData.aabb, 'YN')
        this.offset = SwitchPosYN[1] - SwitchPosY[1]
        this.nodePosition.splice(1, 1, this.nodePosition[1] + this.offset / 2)
      }
      if (this.currentCreateParams.type === 'Platen') {
        const currentNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(
          this.currentCreatedNode
        )
        if (currentNodeInfo.item) {
          const calcAabb = await this.player.Native.ModelTree.calcItemAabbData(currentNodeInfo.item)
          this.nodePosition = [
            this.nodePosition[0],
            this.nodePosition[1] + (calcAabb.aabb[1][1] - calcAabb.aabb[0][1]) / 2,
            this.nodePosition[2] - (calcAabb.aabb[1][2] - calcAabb.aabb[0][2]) / 2,
          ]
        }
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(
        this.currentCreatedNode,
        this.nodePosition
      )
      const codeInfo = {
        type: this.currentCreateParams.type,
        fileType: item.fileType,
        filePath: url,
        documentId: item.documentId,
        documentName: item.documentName,
        documentCode: item.documentCode,
        md5,
        materialFileMd5: materialParams.md5,
        layout: `${this.inputRow}*${this.inputColumn}`,
        model: modelName,
      }
      if (this.currentCreateParams.type === 'Platen') {
        await this.player.Native.NodeProxy.setNodeInfo(this.currentCreatedNode, {
          code: JSON.stringify(codeInfo),
        })
        this.currentPlatenNode = this.currentCreatedNode
        this.PlatenPosition = await this.player.Native.NodeProxy.getNodeInfo(
          this.currentCreatedNode
        )
      }
      // 获取背板的包围盒信息
      // 在每次加载完成时循环加载下一个模型
      if (this.circulateNumber <= this.LoadNumber) {
        if (this.circulateNumber > 0) {
          const text1 = this.platenEditList[this.circulateNumber - 1].firstRow
          const text2 = this.platenEditList[this.circulateNumber - 1].secondRow
          const text = [text1, text2]
          if (text1 || text2) {
            await this.drawNodeMaterial(
              this.currentCreatedNode,
              text,
              md5,
              this.platenEditList[this.circulateNumber - 1].fontSize,
              codeInfo
            )
          } else {
            await this.drawNodeMaterial(
              this.currentCreatedNode,
              ['备用'],
              md5,
              this.platenEditList[this.circulateNumber - 1].fontSize,
              codeInfo
            )
          }
          return
        }
        this.circulateNumber = 1
      }
    },
    // 获取模型偏移量
    async getNodeOffset() {
      const depthBoardNode = await this.player.Native.NodeProxy.findFirstNodeByName(
        this.currentNodeData.nodePtr,
        'depthBoard_front'
      )
      if (depthBoardNode) {
        const depthBoardInfo = await this.player.Native.NodeProxy.getNodeInfo(depthBoardNode)
        if (depthBoardInfo.item) {
          const depthBoardAabb = await this.player.Native.ModelTree.calcItemAabbData(
            depthBoardInfo.item
          )
          const frontCenter = Aabb.faceCenter(depthBoardAabb.aabb, 'YN')
          const topCenter = Aabb.faceCenter(depthBoardAabb.aabb, 'Z')
          const initPos = [frontCenter[0], frontCenter[1], topCenter[2]]
          const cabinetChilds = await this.player.Native.NodeProxy.getNodeChildren(
            this.currentNodeData.nodePtr
          )
          const filterList = _.filter(cabinetChilds, (item) => {
            return (
              isJSONObj(item.code) &&
              (JSON.parse(item.code).type === 'Instrument' ||
                JSON.parse(item.code).type === 'Platen')
            )
          })
          let zDeviation = 0
          for (let i = 0; i < filterList.length; i += 1) {
            // eslint-disable-next-line no-await-in-loop
            const calcAabb = await this.player.Native.ModelTree.calcItemAabbData(filterList[i].item)
            zDeviation += calcAabb.aabb[1][2] - calcAabb.aabb[0][2]
          }
          this.nodePosition = [initPos[0], initPos[1], initPos[2] - zDeviation]
        }
      }
    },
    // 模型加载相关
    // 表格选择
    selectionTableChange(selections, row) {
      this.$refs.nodeTable.clearSelection()
      this.selectionNode = row
      this.$refs.nodeTable.toggleRowSelection(row, true)
    },
    // 表格筛选
    filterNodeList() {
      this.dataList = _.filter(this.orignList, (item) => {
        return item.name.search(this.searchKey) >= 0 || item.code.model.search(this.searchKey) >= 0
      })
    },
    // 选择背板切换
    selectChange(data) {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      data.select = !data.select
    },
    // 选择压板样式切换
    selectOtherChange(data) {
      _.forEach(this.deviceOtherList, (item) => {
        item.select = false
      })
      data.select = !data.select
    },
    // 获取压板列表
    async getPlatenList() {
      // 获取当前选中模型子级
      const subNodes = await this.player.Native.NodeProxy.getNodeChildren(
        this.currentNodeData.nodePtr
      )
      const filterList = _.filter(subNodes, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Platen'
      })
      this.orignList = _.map(filterList, (el) => {
        return {
          code: JSON.parse(el.code),
          id: el.id,
          item: el.item,
          name: el.name,
          nodePtr: el.nodePtr,
          parentPtr: el.parentPtr,
          type: el.type,
        }
      })
      this.dataList = _.cloneDeep(this.orignList)
    },
    // 加载背板模型节点
    async loadPlaten_Node() {
      const params = {
        modifyNode: null,
        documentDataList: this.isSelectList,
        type: 'Platen',
        name: this.currentNodeName,
        positionType: '',
        faceValue: this.nodePositionValue,
      }
      this.createNode(params)
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      _.forEach(this.deviceOtherList, (item) => {
        item.select = false
      })
    },
    // 加载压板样式模型节点
    async loadPlaten_OtherNode() {
      const params = {
        modifyNode: null,
        documentDataList: this.isSelectOtherList,
        type: 'PlatenSwitch',
        name: this.currentNodeName,
        positionType: 'PressurePlateStyle',
        faceValue: this.nodePositionValue,
      }
      if (this.circulateNumber === 1) {
        this.OtherParams = params
        this.createNode(params)
      } else {
        this.createNode(this.OtherParams)
      }
      _.forEach(this.deviceOtherList, (item) => {
        item.select = false
      })
    },
    // 加载节点
    async loadNode() {
      this.isSelectOtherList = _.filter(this.deviceOtherList, ['select', true])
      this.isSelectList = _.filter(this.deviceList, ['select', true])
      if (
        this.isSelectOtherList.length > 0 &&
        this.isSelectList.length > 0 &&
        this.inputRow !== 0 &&
        this.inputColumn !== 0
      ) {
        this.loadPlaten_Node()
      } else {
        this.$message.warning('请选择设备进行添加且输入行列数')
      }
    },
    // 获取背板的文件路径id
    async getFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '压板背板',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '压板背板'
          })
          if (currentFolder) {
            this.defaultFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取压板样式的文件路径id
    async getOtherFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '压板开关样式',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '压板开关样式'
          })
          if (currentFolder) {
            this.defaultOtherFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取属性模板
    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 获取背板列表
    async getDataList(val) {
      if (val) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: val,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
          keyWord: this.searchTypeKey,
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.deviceList = _.map(res.data.items, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 获取压板样式列表
    async getOtherDataList(val) {
      if (this.defaultOtherFolderId) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: val,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
          keyWord: this.searchTypeKey,
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.deviceOtherList = _.map(res.data.items, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 获取压板样式列表
    async getLabelDataList(val) {
      if (this.defaultLabelFolderId) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: val,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
        }
        // 拼接属性模板搜索条件
        if (this.templateAttrSetList) {
          const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
            return item.attrbuteDetail.displayName === '型号'
          })
          query.searchItems = [
            {
              tableName: this.templateAttrSetList[0].tableName,
              tableItems: [
                {
                  fieldName: attrValue.fieldName,
                  fieldValue: '',
                  valueType: attrValue.valueType,
                },
              ],
            },
          ]
        }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.labelList = _.map(res.data.items, (item) => {
            return {
              ...item,
            }
          })
        }
      }
    },
    // 取消编辑
    cancleModify() {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      _.forEach(this.deviceOtherList, (item) => {
        item.select = false
      })
      this.selectionNode = null
      this.isEdit = false
      setTimeout(() => {
        this.getPlatenList()
        this.$refs.nodeTable.clearSelection()
      }, 500)
    },
    // 去到新增页面
    addNode() {
      this.isEdit = true
    },
    // 去到编辑
    editNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择模型修改模型')
        return
      }
      this.currentNodeName = this.selectionNode.name
      this.isEdit = true
    },
    // 删除节点
    async deleteNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择需要删除的模型')
        return
      }
      if (this.selectionNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.selectionNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.selectionNode.nodePtr)
        this.selectionNode = null
        this.$refs.nodeTable.clearSelection()
        this.getPlatenList()
        this.$emit('updateEditTree', '')
      }
    },
    plateCountChange() {
      this.LoadNumber = this.inputColumn * this.inputRow
      this.platenEditList = []
      for (let i = 0; i < this.inputRow; i++) {
        const row = i + 1
        for (let s = 0; s < this.inputColumn; s++) {
          const column = s + 1
          this.platenEditList.push({
            row,
            toolName: `开关${row}*${column}`,
            fontSize: 12,
            status: true,
            firstRow: '',
            secondRow: '',
            objNumber: '',
          })
        }
      }
    },
    // 编辑标签文字
    platenName() {
      this.platenEditSaveList = this.platenEditList
      this.EditCardList = []
      for (let i = 1; i <= this.inputRow; i++) {
        let arr = []
        arr = this.platenEditSaveList.filter((item) => {
          return item.row === i
        })
        this.EditCardList.push(arr)
      }
      this.platenEdit = true
    },
  },
  data() {
    return {
      currentCreatedNode: null,
      currentSwitchModel: '',
      currentSwitchMd5: '',
      currentSwitchFile: '',
      currentSwitchInfo: {},
      currentSwitchMaterial: {},
      EditCardList: [],
      currentPlatenNode: null,
      currentTagFile: {},
      isSelectLableList: [],
      labelList: [],
      defaultLabelFolderId: null,
      platenEditList: [],
      platenEditSaveList: [],
      platenEdit: false,
      OtherParams: '',
      isSelectOtherList: '',
      isSelectList: '',
      LoadNumber: 0,
      circulateNumber: 0,
      nodePositionList: [],
      inputRow: 0,
      inputColumn: 0,
      PlatenPosition: [], // 背板的包围盒信息
      PlatenOtherPosition: [], // 开关样式的包围盒信息
      isEdit: false,
      listLoading: false,
      selectionNode: null,
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      searchKey: '',
      currentNodeName: '', // 对象名称
      searchTypeKey: '', // 列表搜索
      showListData: true,
      dataList: [],
      orignList: [], // 原始数据
      deviceList: [],
      deviceOtherList: [],
      tableLoading: false,
      defaultFolderId: null, // 背板的文件路径id
      defaultOtherFolderId: null, // 压板样式文件路径id
      templateAttrSetList: [],
      addTypeValue: 2, // 添加类型
      nodePositionValue: 'YN', // 节点位置
      offset: 0,
      nodePostionProp: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
    }
  },
}
</script>
<style lang="scss" scoped>

@import '../../../css/index.scss';
@import '../../../css/select.scss';
#Platen {
  width: 100%;
  height: 100%;
}
/deep/.player_progress {
  position: fixed !important;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  display: none !important;
}
/deep/.el-input.is-disabled input {
  color: #c0c4cc !important;
}
/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
  border-color: #409eff !important;
  background: #409eff !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
  max-width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-content {
  height: calc(100% - 48px);
  background-color: rgba(24, 41, 72, 0.5);
}
.create_new {
  z-index: 999;
  position: absolute;
  bottom: 15px;
  right: 10px;
}
.Platen_style {
  width: 100%;
  height: 140px;
  overflow: auto;
  background: rgba(24, 41, 72, 0.5);
  p {
    height: 20px;
    line-height: 20px;
  }
  .model-list {
    height: calc(100% - 40px);
    overflow-y: auto;
    .model-item {
      height: 95px;
      .item-img {
        height: calc(100% - 20px);
        background-color: #383b3b !important;
      }
      .item-title {
        height: 20px;
        line-height: 20px;
      }
    }
    .model-item:hover {
      background-color: rgba(46, 107, 176, 0.5) !important;
    }
  }
}
.Platen_style_card:hover {
  border-radius: 5px;
  background: rgba($color: #d6d4d4, $alpha: 0.1);
}
.Platen_style_card {
  margin: 10px 10px;
  width: 85px;
  height: 70px;
  padding: 5px 8px;
}
.Platen_layout {
  font-size: 12px;
  position: relative;
  width: 100%;
  background: rgba(24, 41, 72, 0.5);
  .Platen_layout_edit {
    float: right;
    position: relative;
    right: 15px;
    width: 422px;
  }
  .Platen_layout_title {
    margin: 10px 10px;
    height: 50px;
    line-height: 50px;
  }
}
.Platen_layout_right {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  width: 210px;
  height: 40px;
  span {
    margin-right: 5px;
    line-height: 32px;
  }
}
.Platen_back_style {
  height: calc(100% - 305px);
  background: rgba(24, 41, 72, 0.5);
  overflow: auto;
  .model-list {
    height: calc(100% - 52px);
    overflow-y: auto;
    .model-item {
      height: 95px;
      .item-img {
        height: calc(100% - 20px);
        background-color: #383b3b !important;
      }
      .item-title {
        height: 20px;
        line-height: 20px;
      }
    }
    .model-item:hover {
      background-color: rgba(46, 107, 176, 0.5) !important;
    }
  }
  .Platen_back_list {
    display: flex;
    height: 125px;
    overflow: auto;
    flex-wrap: wrap;
  }
}
.card-footer {
  border: none !important;
}
.PlatenEidt {
  height: 480px;
  background: rgba(24, 41, 72, 0.5);
  .PlatenEidt_content {
    overflow-y: auto;
    height: calc(100% - 10px);
    .context_card {
      width: 250px;
      height: 90%;
      background: rgba(12, 37, 83, 0.5);
      .card_title {
        text-align: center;
      }
    }
  }
}
.PlatenEidt_content_row {
  display: flex;
  overflow-x: auto;
  height: 47%;
}
.platenBottom {
  height: 40px;
}

</style>
